var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboAddCircleSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.14 1 1 4.14 1 8C1 11.86 4.14 15 8 15C11.86 15 15 11.86 15 8C15 4.14 11.86 1 8 1ZM8 13.78C4.81333 13.78 2.22 11.1867 2.22 8C2.22 4.81333 4.81333 2.22 8 2.22C11.1867 2.22 13.78 4.81333 13.78 8C13.78 11.1867 11.1867 13.78 8 13.78Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7406 7.39337H8.60727V5.26004C8.60727 5.09337 8.47393 4.95337 8.3006 4.95337H7.69393C7.52727 4.95337 7.38727 5.0867 7.38727 5.26004V7.39337H5.25393C5.08727 7.39337 4.94727 7.5267 4.94727 7.70004V8.3067C4.94727 8.47337 5.0806 8.61337 5.25393 8.61337H7.38727V10.7467C7.38727 10.9134 7.5206 11.0534 7.69393 11.0534H8.3006C8.46727 11.0534 8.60727 10.92 8.60727 10.7467V8.61337H10.7406C10.9073 8.61337 11.0473 8.48004 11.0473 8.3067V7.70004C11.0473 7.53337 10.9139 7.39337 10.7406 7.39337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboAddCircleSmall);
export default __webpack_public_path__ + "static/media/FBOAddCircleSmall.1776ecfd2f47f30905bedf05ebdbfe2e.svg";
export { ForwardRef as ReactComponent };